import { IIconBase } from '..'

const leftArrowIcon = ({
  color = '#292D32',
  height = 24,
  width = 24,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/arrow-square-left'>
        <g id='arrow-square-left'>
          <path
            id='Vector'
            d='M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M13.26 15.5307L9.73999 12.0007L13.26 8.4707'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export default leftArrowIcon
